<template>
    <div>
        <div v-for="(method, i) in paymentMethods" :key="i">
            <vs-checkbox v-model="method.checked" class="mb-1">
                    {{ method.label }}
            </vs-checkbox>

            <vs-divider  border-style="dashed" />
        </div>
    </div>
</template>

<script>
    import { AvailablePayments } from './PaymentMethods.js'

    export default {
        props : {
            initialMethods : {
                type : Array,
                required : true,
            }
        },

        data () {
            return {
                paymentMethods : []
            }
        },

        watch : {
            initialMethods (val) {
                
            },

            paymentMethods : {
                deep : true,
                handler(val) {
                    let obj = []

                    this.paymentMethods.forEach(method => {
                        if(method.checked) obj.push(method.name)
                    })
                    this.$emit('checked', obj)
                }
            }
        },

        mounted () {
            AvailablePayments.forEach(method => {

                this.paymentMethods.push({
                    checked : this.initialMethods.find(a => a == method) != undefined,
                    name : method,
                    label : this.$t(method)
                })
            })
        }
    }
</script>